import { render, staticRenderFns } from "./BudgetSelection.vue?vue&type=template&id=11554397&scoped=true&"
import script from "./BudgetSelection.vue?vue&type=script&lang=js&"
export * from "./BudgetSelection.vue?vue&type=script&lang=js&"
import style0 from "./BudgetSelection.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BudgetSelection.vue?vue&type=style&index=1&id=11554397&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11554397",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11554397')) {
      api.createRecord('11554397', component.options)
    } else {
      api.reload('11554397', component.options)
    }
    module.hot.accept("./BudgetSelection.vue?vue&type=template&id=11554397&scoped=true&", function () {
      api.rerender('11554397', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/BudgetSelection.vue"
export default component.exports